import { blockScroll } from '@uefadigital/panenka';
import { useEffect } from 'react';
import ReactModal from 'react-modal';

const Modal = ({
  children,
  showModal,
  className,
  overlayClassName,
}: {
  children: React.ReactNode;
  showModal: boolean;
  className: string;
  overlayClassName: string;
}) => {
  useEffect(() => {
    blockScroll(showModal, 'got-modal');

    return () => {
      blockScroll(false, 'got-modal');
    };
  }, [showModal]);

  return (
    <div>
      <ReactModal isOpen={showModal} overlayClassName={overlayClassName} className={className} ariaHideApp={false}>
        {children}
      </ReactModal>
    </div>
  );
};

export default Modal;
